export const ACCESS_TYPE = 'sse'; // ws or sse 标志链接方式
export const APP_KEY = 'WFRgmiXs'; // 体验机器人的appkey



// WEBPACK FOOTER //
// ./src/constants/static.js